import { createFileRoute } from "@tanstack/react-router";
import { ProfileView } from "@/features/auth";

export const Route = createFileRoute("/profile")({
	component: ProfileView,
});
